import React from "react";

const PlaceholderVideo = () => (
  <div className="d-flex justify-content-center align-items-center w-100 h-100 bg-lightblue">
    <i className="bx bx-movie font-size-20 text-primary" />
  </div>
);

export default PlaceholderVideo;
